import { FunctionComponent } from 'react';
import PageSidebar from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import DaycareComponent from 'components/Daycare/DaycareComponent';
import { useServiceCategoryAccess } from 'hooks';
import { Redirect } from 'react-router-dom';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';

interface ServicesProps {
    create: string;
}

export const Daycare: FunctionComponent<ServicesProps> = props => {
    const { isAllowed, redirectTo } = useServiceCategoryAccess('daycare');
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('daycare');

    if (!isAllowed) {
        return <Redirect to={redirectTo} />;
    }

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    return (
        <PrivatePage
            title="Daycare - Cuddles"
            pageName="/daycare"
            pageSidebar={sidebar}
        >
            <DaycareComponent />
        </PrivatePage>
    );
};

export default Daycare;
